/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SharepointDriveData = {
  id: string;
  name: string;
};

/** @internal */
export const SharepointDriveData$inboundSchema: z.ZodType<
  SharepointDriveData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
});
/** @internal */
export type SharepointDriveData$Outbound = {
  id: string;
  name: string;
};

/** @internal */
export const SharepointDriveData$outboundSchema: z.ZodType<
  SharepointDriveData$Outbound,
  z.ZodTypeDef,
  SharepointDriveData
> = z.object({
  id: z.string(),
  name: z.string(),
});

export function sharepointDriveDataToJSON(
  sharepointDriveData: SharepointDriveData,
): string {
  return JSON.stringify(
    SharepointDriveData$outboundSchema.parse(sharepointDriveData),
  );
}
export function sharepointDriveDataFromJSON(
  jsonString: string,
): SafeParseResult<SharepointDriveData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SharepointDriveData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SharepointDriveData' from JSON`,
  );
}
